import { mainSiteUrl } from '@/mocks/categories';

const productItems = [
  {
    name: 'Jackets & Outerwear',
    desc: 'Premium selection of seasonal outerwear',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20bomber%20jacket%20displayed%20on%20industrial%20black%20metal%20rack%20against%20concrete%20wall%2C%20dramatic%20side%20lighting%20creating%20sharp%20shadows%2C%20edgy%20urban%20fashion%20editorial%2C%20dark%20moody%20atmosphere%2C%20rich%20olive%20green%20fabric%20texture%2C%20high%20end%20streetwear%20aesthetic%2C%20sophisticated%20loft%20setting&width=700&height=900&seq=prod-v2-jackets-01&orientation=portrait',
    tag: 'Trending',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    isLarge: true,
  },
  {
    name: 'Premium Sneakers',
    desc: 'Curated footwear collection',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20multicolor%20athletic%20sneakers%20suspended%20in%20mid-air%20with%20motion%20freeze%20effect%2C%20colorful%20powder%20explosion%20background%20in%20neon%20pink%20blue%20and%20yellow%2C%20dynamic%20sports%20action%20photography%2C%20energetic%20youthful%20style%2C%20festival%20atmosphere%2C%20high%20speed%20capture%2C%20bold%20saturated%20colors&width=600&height=800&seq=prod-v2-sneakers-02&orientation=portrait',
    tag: 'In Stock',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    isLarge: false,
  },
  {
    name: 'Designer Bags',
    desc: 'Luxury accessories selection',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20designer%20handbag%20on%20polished%20black%20marble%20surface%20with%20gold%20chain%20accent%2C%20dramatic%20spotlight%20illumination%2C%20luxury%20boutique%20window%20display%20style%2C%20deep%20shadows%20and%20bright%20highlights%2C%20rich%20cognac%20leather%20texture%2C%20high%20fashion%20editorial%2C%20opulent%20sophisticated%20aesthetic&width=600&height=800&seq=prod-v2-bags-03&orientation=portrait',
    tag: 'Popular',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    isLarge: false,
  },
];

export default function ProductGrid() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-4">
              Discover
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
              Latest Drops
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            Updated weekly from verified sources on the <strong className="font-semibold text-foreground-700">best vigorbuy spreadsheet</strong>.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productItems.map((item, i) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative overflow-hidden rounded-3xl transition-all duration-300 hover:scale-[1.02] cursor-pointer ${
                item.isLarge ? 'md:col-span-2 md:row-span-1' : ''
              }`}
              style={{ minHeight: item.isLarge ? '420px' : '380px' }}
            >
              {/* Background */}
              <div className="absolute inset-0">
                <img
                  src={item.imageUrl}
                  alt={`${item.name} - Vigorbuy Spreadsheet Product`}
                  title={`${item.name} - Vigorbuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>

              {/* Tag */}
              <span className="absolute top-5 left-5 z-10 px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium">
                <span className="w-1.5 h-1.5 inline-block rounded-full bg-green-400 mr-1.5"></span>
                {item.tag}
              </span>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 z-10">
                <h3 className="text-xl md:text-2xl font-bold text-white font-heading mb-1">
                  {item.name}
                </h3>
                <p className="text-sm text-white/70 mb-4">{item.desc}</p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-white/90 group-hover:text-white transition-colors duration-200">
                  Shop Now
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-800 font-semibold text-sm hover:border-foreground-900 hover:text-foreground-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Browse All Products
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}